/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I1_LabelInputs */

const tr_kullanim_s2_i1_label = /** @type {(inputs: Kullanim_S2_I1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform / ShopPanel™:`)
};

const en_kullanim_s2_i1_label = /** @type {(inputs: Kullanim_S2_I1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform / ShopPanel™:`)
};

const de_kullanim_s2_i1_label = /** @type {(inputs: Kullanim_S2_I1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform / ShopPanel™:`)
};

const ru_kullanim_s2_i1_label = /** @type {(inputs: Kullanim_S2_I1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа / ShopPanel™:`)
};

/**
* | output |
* | --- |
* | "Platform / ShopPanel™:" |
*
* @param {Kullanim_S2_I1_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i1_label = /** @type {((inputs?: Kullanim_S2_I1_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I1_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i1_label(inputs)
	if (locale === "de") return de_kullanim_s2_i1_label(inputs)
	if (locale === "ru") return ru_kullanim_s2_i1_label(inputs)
	return tr_kullanim_s2_i1_label(inputs)
});